const { mapValues, groupBy, sumBy, isEmpty, } = require('lodash');
const { format: formatDate, } = require('date-fns');

const locales = {
  ja: { label: '日本語', },
  en: { label: '英語', },
};

const currencies = {
  yen: { label: '日本円', },
  usd: { label: 'USドル', },
};

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      name: {
        label: '名称',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      locale: {
        label: '言語',
        type: 'select',
        options: entries(locales).map(([k, v]) => ({ label: v.label, value: k })),
        validations: {
          required: v => !isEmpty(v),
        },
      },
      currency: {
        label: '通貨',
        type: 'select',
        options: entries(currencies).map(([k, v]) => ({ label: v.label, value: k })),
        validations: {
          required: v => !isEmpty(v),
        },
      },
      emailTo: {
        label: 'メールTO',
        type: 'string',
        hint: 'カンマ区切りで複数指定できます',
      },
    };
  },
  locales,
  currencies,
};
